export default __webpack_public_path__ + "static/media/rambouillet23.6b50baf1.jpg";